import React from 'react'
import { Box, TextField } from '@mui/material'
import { ReactComponent as SearchIcon } from '../../common/icons/search.svg'

export default function SearchField({ searchText, setSearchText, onSearch }) {
  const handleSearchChange = e => {
    const value = e.target.value
    setSearchText(value)
    onSearch(value)
  }

  return (
    <Box width='280px'>
      <TextField
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            border: '1px solid #E7E7EE',
            background: '#fff',
            width: '100%'
          }
        }}
        InputProps={{
          endAdornment: <SearchIcon />
        }}
        onChange={handleSearchChange}
        value={searchText}
        size='small'
        placeholder='Search Topics'
      />
    </Box>
  )
}
